import React from 'react';

interface LoadingOverlayProps {
  /** 加载提示文字 */
  text?: string;
  /** 背景样式 */
  bgStyle?: 'white' | 'black' | 'gray';
  /** spinner颜色，默认primary-500 */
  spinnerColor?: string;
  /** 文字颜色，默认gray-700 */
  textColor?: string;
  /** 自定义类名 */
  className?: string;
}

/**
 * 统一的Loading遮罩组件
 * 样式与3D预览弹窗保持一致
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  text,
  bgStyle = 'white',
  spinnerColor = 'border-primary-500',
  textColor = 'text-gray-700',
  className = '',
}) => {
  const getBgStyle = () => {
    switch (bgStyle) {
      case 'black':
        return 'bg-black/40';
      case 'gray':
        return 'bg-gray-100/90';
      case 'white':
      default:
        return 'bg-white/90';
    }
  };

  return (
    <div className={`absolute inset-0 flex items-center justify-center ${getBgStyle()} z-10 ${className}`}>
      <div className="text-center">
        <div className={`inline-block animate-spin rounded-full h-12 w-12 border-b-2 ${spinnerColor} mb-4`}></div>
        {text && <div className={`${textColor} text-sm`}>{text}</div>}
      </div>
    </div>
  );
};

export default LoadingOverlay;
